import { chakra } from '@chakra-ui/react';

/** First tab stop on every page (WCAG 2.4.1): invisible until keyboard
 * focus lands on it, then surfaces above the chrome. Jumps to the app's
 * main content region (#main-content). */
export function SkipToContent() {
    return (
        <chakra.a
            data-sentry-unmask
            href='#main-content'
            position='fixed'
            top={2}
            left={2}
            // Above the sidebar (1000).
            zIndex={1100}
            px={4}
            py={2}
            rounded='md'
            borderWidth='1px'
            bg='bg.panel'
            textStyle='body-3'
            // Parked off-viewport, not display:none — it must stay
            // focusable for the skip to work.
            transform='translateY(calc(-100% - var(--chakra-spacing-4)))'
            _focusVisible={{
                transform: 'none',
                outlineWidth: '2px',
                outlineStyle: 'solid',
                outlineColor: 'colorPalette.focusRing',
            }}
        >
            Skip to content
        </chakra.a>
    );
}
